import React from 'react'
import * as Yup from 'yup'
import ChangePasswordForm from './ChangePasswordForm'

const ChangePassword = () => {
    const validationPassword = Yup.object({
        change_password: Yup.boolean(),
        current_password: Yup.string().required('Required'),
        new_password: Yup.string()
            .notOneOf([Yup.ref('current_password')], 'New password must be different')
            .matches(
                /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]/,
                'Password must include uppercase and lowercase letters, a number, and a special character.',
            )
            .min(8, 'Minimum 8 Characters')
            .required('Required'),
        confirm_password: Yup.string()
            .oneOf([Yup.ref('new_password')], 'Passwords Not Match')
            .required('Required'),
    })
    const initialValues = {
        change_password: 1,
        current_password: '',
        new_password: '',
        confirm_password: '',
    }

    const changePassword = [
        {
            label: 'Current Password',
            name: 'current_password',
            type: 'password',
            placeholder: 'Enter your Current password',
            class: 'col-12',
        },
        {
            label: 'New Password',
            name: 'new_password',
            type: 'password',
            placeholder: 'Enter your New password',
            class: 'col-12',
        },
        {
            label: 'Confirm New Password',
            name: 'confirm_password',
            type: 'password',
            placeholder: 'Re enter your password',
            class: 'col-12',
        },
    ]

    return (
        <ChangePasswordForm
            validationPassword={validationPassword}
            initialValues={initialValues}
            data={changePassword}
        />
    )
}

export default ChangePassword
